/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  width: calc(460rem/14);
  min-width: calc(50rem/14);
}
:host .pl_label, :host .pl_report {
  font-size: inherit;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  line-height: calc(22rem/14);
}
:host .pl_horizontal {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
}
:host .pl_horizontal .pl_outer {
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  height: calc(8rem/14);
  width: 100%;
  position: relative;
  background-color: #B4BEC5;
  background-color: var(--davinci-color-midgray-2, #B4BEC5);
  margin-right: calc(12rem/14);
}
:host .pl_horizontal .pl_outer .pl_inner {
  height: calc(8rem/14);
  position: relative;
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}

.pl_horizontal ::slotted(*) {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
}`;
export { style };
//# sourceMappingURL=ProgressLine.style.js.map